import { Box, Skeleton, Typography } from "@mui/material";
import { useTableLayoutClasses } from "../TableLayout.style";
import useLanguages from "../../../../../explorer/hooks/useLanguages";

type TDiscountComponent = {
    item: any;
    additionalProps?: any;
    colName: any;
};

const DiscountComponent = (props: TDiscountComponent) => {
    const classes = useTableLayoutClasses();
    const { item, additionalProps, colName } = props;
    const lang = useLanguages().currentLanguage;
    const discount = (
        item as {
            [key: string]: any;
        }
    )[colName];

    return (
        <Box
            sx={
                discount > 0
                    ? classes.iconCell
                    : { visibility: "hidden" }
            }
        >
            {discount ? (
                <Typography sx={classes.columnDiscount}>
                    {discount !== 0 &&
                        discount !== undefined &&
                        Intl.NumberFormat(lang, {
                            style: "percent",
                        }).format(-Math.abs(Number(discount) / 100))}
                </Typography>
            ) : (
                <Skeleton width={50} />
            )}
        </Box>
    );
};

export default DiscountComponent;
